import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import AccountRegistrationComponent from './account-registration.component';

let AccountRegistrationModule = angular
  .module('AccountRegistration', [
    uiRouter
  ])
  .component('accountRegistration', AccountRegistrationComponent)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state('accountRegistration', {
      params: {
        profiles: null
      },
      data: {
        authRequired: true,
        paymentExempt: true,
        permsRequired: []
      },
      views: {
        'menu': "",
        'content': {
          component: 'accountRegistration'
        }
      },
      resolve: {
        invitations: ($transition$, $q) => {
          // NOTE: A call to ContentService.getUserInvitations() was being made, deacttivated
          // in exchange of a parameter (for more info see commit 7f5215d1b).
          var invitationsFromParams = $transition$.params().invitations || [];
          return $q((resolve, reject) => {
            resolve(invitationsFromParams);
          });
        },
        countries: (CountriesService) => CountriesService.getCountries(),
        profiles: ($transition$) => {
          return $transition$.params().profiles || [];
        },
      }
    });
  })
  .name;

export default AccountRegistrationModule;



// WEBPACK FOOTER //
// ./src/app/pages/account-registration/account-registration.module.js